import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute, SessionRoute } from "@/components/layout/ProtectedRoute";
import { AppLayout } from "@/components/layout/AppLayout";
import { PageFallback } from "@/components/layout/PageFallback";
import { Home } from "@/pages/Home";

// As páginas são lazy — cada uma vira um pedaço carregado sob demanda, em vez de tudo ir junto
// no bundle inicial.
const Login = lazy(() => import("@/pages/auth/Login"));
const Register = lazy(() => import("@/pages/auth/Register"));
const ForgotPassword = lazy(() => import("@/pages/auth/ForgotPassword"));
const Onboarding = lazy(() => import("@/pages/Onboarding"));
const loadDashboard = () => import("@/pages/Dashboard");
const Dashboard = lazy(loadDashboard);
const Landing = lazy(() => import("@/pages/Landing/Landing"));
const Transactions = lazy(() => import("@/pages/Transactions"));
const Accounts = lazy(() => import("@/pages/Accounts"));
const GoalsBudgets = lazy(() => import("@/pages/GoalsBudgets"));
const CalendarPage = lazy(() => import("@/pages/Calendar"));
const Settings = lazy(() => import("@/pages/Settings"));
const Premium = lazy(() => import("@/pages/Premium"));
const Admin = lazy(() => import("@/pages/Admin"));
const Terms = lazy(() => import("@/pages/legal/Terms"));
const PrivacyPolicy = lazy(() => import("@/pages/legal/PrivacyPolicy"));
const NotFound = lazy(() => import("@/pages/NotFound"));

// Quem chega de fora (anúncio, link) cai em "/" e é levado pro dashboard - é a primeira tela de
// quase todo visitante. Começa a baixar esse pedaço já, junto com o resto, em vez de só depois
// do primeiro render.
if (["/", "/dashboard"].includes(window.location.pathname)) void loadDashboard();

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Register />} />
        <Route path="/recuperar-senha" element={<ForgotPassword />} />
        <Route path="/termos" element={<Terms />} />
        <Route path="/privacidade" element={<PrivacyPolicy />} />
        <Route path="/sobre" element={<Landing />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/onboarding" element={<Onboarding />} />
        </Route>

        {/* Telas do app: abertas também pro visitante sem conta, em modo demonstração. */}
        <Route element={<SessionRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/lancamentos" element={<Transactions />} />
            <Route path="/calendario" element={<CalendarPage />} />
            <Route path="/contas" element={<Accounts />} />
            <Route path="/orcamento" element={<Navigate to="/metas" replace />} />
            <Route path="/contas-a-pagar" element={<Navigate to="/metas" replace />} />
            <Route path="/metas" element={<GoalsBudgets />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/configuracoes" element={<Settings />} />
              <Route path="/premium" element={<Premium />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
